import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import Button from "../Button";

export default function ScheduleTestingForm({
  sampleIds,
  onSampleUpdate,
  reloadData,
  loadSelectedSamples
}) {
  const [loading, setLoading] = useState(false);

  const valid = sampleIds.length > 0;

  const scheduleSamples = () => {
    if (!valid) return;
    setLoading(true);
    post("/scheduling/schedules", {
      sample_ids: sampleIds
    })
      .then(json => {
        if (json.errors) {
          alert(json.errors);
        } else {
          setLoading(false);
          loadSelectedSamples();
        }
      })
      .catch(errors => {
        alert(errors);
        setLoading(false);
        throw errors;
      });
  };

  return (
    <div className="contract-review-form">
      <p>There are {sampleIds.length} selected samples</p>
      <Button
        disabled={!valid || loading}
        onClick={scheduleSamples}
        title={loading ? "Please wait..." : I18n.t("schedule_samples")}
        primary
      />
    </div>
  );
}
